import styled from 'styled-components';
import HotelFailedSvg from '../../assets/mytrips/hotel-failed.svg';

const HotelFailedIcon = styled(HotelFailedSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.5rem'};
  height: ${props => props.height || '2.5rem'};
  margin: ${props => props.margin};
`;

export default HotelFailedIcon;
